import { config, dashApi } from 'services/api';

export async function getContact(page, limit) {
  return dashApi.get('contact/', config({ page, limit }));
}

export async function getDownload() {
    return dashApi.get('contact/download/', config());
  }
